import { render } from "./OnlineCareResponse.vue?vue&type=template&id=c920e2f4&scoped=true&ts=true"
import script from "./OnlineCareResponse.vue?vue&type=script&lang=ts"
export * from "./OnlineCareResponse.vue?vue&type=script&lang=ts"

import "./OnlineCareResponse.vue?vue&type=style&index=0&id=c920e2f4&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c920e2f4"]])

export default __exports__